import React from 'react';

import type { CustomStep, CustomStepType } from '@shared/patient-intake-status';

import { usePatientIntakeStatusContext } from '../../../hooks';
import { MessageStepViewer } from './MessageStepViewer.tsx';
import { DocumentUploadStepViewer } from './DocumentUploadStepViewer.tsx';
import { DischargeLetterStepViewer } from './DischargeLetterStepViewer.tsx';

const throwNever = (type: never) => {
  throw new Error(`Unknown custom step type: ${type}`);
};

type CurrentStatusViewerProps = {
  step: CustomStep[CustomStepType];
};

/**
 * This is a component that displays the current status metadata of a custom step.
 * E.g., say the user has uploaded a document, the current status viewer will display the document
 * details.
 */
export const CurrentStatusViewer: React.FC<CurrentStatusViewerProps> = ({ step }) => {
  const { patientId } = usePatientIntakeStatusContext();
  const { type } = step;

  if (type === 'DOCUMENT_UPLOAD') {
    return <DocumentUploadStepViewer step={step} patientId={patientId} />;
  }

  if (type === 'MESSAGE') {
    return <MessageStepViewer step={step} />;
  }

  if (type === 'DISCHARGE_LETTER_UPLOAD') {
    return <DischargeLetterStepViewer step={step} patientId={patientId} />;
  }

  return throwNever(type);
};
